export var CarrolLaborRoutes = {
    "/carrol-labor": {
        "loginRequired": true,
        "name": "appLayout.schedule.carrol-labor",
        "showGlobalSearch": true,
        "type": "frontend",
        "views": {
            "body": {
                "component": "carrolLaborWeeksListContainer"
            }
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./../activity-based-scheduling-generation/activity-based-scheduling-generation.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("./carrol-labor.module.js");
                }
            },
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["carrol-labor", "abs-generation"]
        },
        "onEnter": ['userServices', '$state', 'TeamScheduleService', 'hUser',
            function (userServices, $state, TeamScheduleService, hUser) {
                TeamScheduleService.getActiveBrand()
                    .then(function (brand) {
                        userServices.isServiceEnabled(userServices.SERVICES.CARROL_LABOR_MODEL, brand.id)
                            .then(function (isCarrolLaborServiceEnabled) {
                                if (!isCarrolLaborServiceEnabled || !hUser.hasSalesAccess()) {
                                    $state.go("appLayout.schedule.main");
                                }
                            })
                            .catch(function (err) {
                                console.error(err);
                            });
                    });
            }]
    },
    "/carrol-labor-projections?date": {
        "loginRequired": true,
        "name": "appLayout.schedule.carrol-labor-projections",
        "showGlobalSearch": true,
        "type": "frontend",
        "views": {
            "body": {
                "component": "carrolLaborProjectionsContainer"
            }
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./../activity-based-scheduling-generation/activity-based-scheduling-generation.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("./../../activity-based-scheduling/activity-based-scheduling.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("./carrol-labor.module.js");
                }
            },
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["carrol-labor", "abs-generation"]
        },
        "onEnter": ['userServices', '$state', 'TeamScheduleService', 'hUser',
            function (userServices, $state, TeamScheduleService, hUser) {
                TeamScheduleService.getActiveBrand()
                    .then(function (brand) {
                        userServices.isServiceEnabled(userServices.SERVICES.CARROL_LABOR_MODEL, brand.id)
                            .then(function (isCarrolLaborServiceEnabled) {
                                if (!isCarrolLaborServiceEnabled || !hUser.hasSalesAccess()) {
                                    $state.go("appLayout.schedule.main");
                                }
                            })
                            .catch(function (err) {
                                console.error(err);
                            });
                    });
            }]
    }
};